<!--
 * @Author: zb
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:37:56
 * @LastEditTime: 2019-09-27 17:00:53
 * @Version: 1.0
 * @Description:报价详情页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <el-dialog
    :visible.sync="viewManager.visible"
    title="报价详情"
    width="80%"
    @click="viewManager.close"
  >
    <div v-loading="viewManager.loading" class="bid-data">
      <div class="query-header">
        <div class="query-form">
          <el-form ref="invitationForm" :inline="true" :model="invitationForm" label-width="120px">
            <el-row :gutter="12">
              <el-col :span="12">
                <el-form-item v-inputFilter class="capacity-content" label="公司名称">
                  <el-input v-model="invitationForm.companyName" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-inputFilter class="capacity-content" label="联系人">
                  <el-input v-model="invitationForm.companyContact" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="12">
              <el-col :span="12">
                <el-form-item class="capacity-content" label="报价时间">
                  <el-date-picker
                    v-model="invitationForm.offerDate"
                    :editable="false"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="operate-tool">
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="invitationFormSummit"
          >
            <i class="el-icon-search" />查询
          </el-button>
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="resetInvitationForm"
          >
            <i class="el-icon-delete-solid" />
            重置
          </el-button>
        </div>
      </div>
      <div class="bid-data-header">
        <ul>
          <li class="sort" :class="{'descending': !sort.price.isAsc, 'ascending': sort.price.isAsc}" @click="sort.price.sort">
            报价价格
            <span class="caret-wrapper">
              <i class="sort-caret ascending" />
              <i class="sort-caret descending" />
            </span>
          </li>
          <li>公司名称</li>
          <li>联系人</li>
          <li>联系人电话</li>
          <li class="sort" :class="{'descending': !sort.time.isAsc, 'ascending': sort.time.isAsc}" @click="sort.time.sort">
            报价时间
            <span class="caret-wrapper">
              <i class="sort-caret ascending" />
              <i class="sort-caret descending" />
            </span>
          </li>
          <li>操作</li>
        </ul>
      </div>
      <div class="bid-data-body">
        <template v-if="bidData.length===0 && !viewManager.loading">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(item, index) of bidData">
          <div :key="index" class="data-item">
            <ul>
              <li :title="item.offerPrice">{{ item.offerPrice }}</li>
              <li :title="item.companyName">{{ item.companyName }}</li>
              <li :title="item.companyContact">{{ item.companyContact }}</li>
              <li :title="item.contactTel">{{ item.contactTel }}</li>
              <li :title="item.createDate">{{ item.createDate }}</li>
              <li>
                <el-button
                  :disabled="transacted"
                  type="text"
                  @click="refuseBid(item)"
                >{{ transacted? '已成交': '成交' }}</el-button>
              </li>
            </ul>
          </div>
        </template>
      </div>
      <div class="bid-data-pagination">
        <el-pagination
          :current-page="bidPagination.pageNo"
          :total="bidPagination.total"
          :page-size="bidPagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="bidChangeCurrent"
          @size-change="bidChangeSize"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import mixinsFunction from '@/utils/mixinsFunction'
import { Page } from '@/utils/commonDataModel'
import { getBidList, batchIssue } from '@/api/personal/find/goodsManager'
import { formatTime } from '@/shared/filters/formatTimeFilter'
import { setTimeout } from 'timers'

const TRANSACTED_STATUS = '2'
export default {
  mixins: [mixinsFunction],
  data: function() {
    return {
      sort: {
        price: {
          isAsc: false,
          sort: () => {
            this.sort.price.isAsc = !this.sort.price.isAsc
            for (let i = 1; i < this.bidData.length; i++) {
              const value = this.bidData[i]
              let end = i
              if (this.sort.price.isAsc) {
                while (end > 0 && this.bidData[end - 1].offerPrice > value.offerPrice) {
                  this.bidData[end] = this.bidData[end - 1]
                  end--
                }
              } else {
                while (end > 0 && this.bidData[end - 1].offerPrice < value.offerPrice) {
                  this.bidData[end] = this.bidData[end - 1]
                  end--
                }
              }
              this.bidData[end] = value
            }
          }
        },
        time: {
          isAsc: false,
          sort: () => {
            this.sort.time.isAsc = !this.sort.time.isAsc
            for (let i = 1; i < this.bidData.length; i++) {
              const value = this.bidData[i]
              let end = i
              if (this.sort.time.isAsc) {
                while (end > 0 && Date.parse(this.bidData[end - 1].createDate, 'yyyy-MM-dd HH:mm:ss') > Date.parse(value.createDate, 'yyyy-MM-dd HH:mm:ss')) {
                  this.bidData[end] = this.bidData[end - 1]
                  end--
                }
              } else {
                while (end > 0 && Date.parse(this.bidData[end - 1].createDate, 'yyyy-MM-dd HH:mm:ss') < Date.parse(value.createDate, 'yyyy-MM-dd HH:mm:ss')) {
                  this.bidData[end] = this.bidData[end - 1]
                  end--
                }
              }
              this.bidData[end] = value
            }
          }
        }
      },
      goods: {},
      invitationForm: {
        companyName: '',
        companyContact: '',
        offerDate: ''
      },
      bidData: [],
      // 竞价列表表格分页
      bidPagination: new Page()
    }
  },
  computed: {
    transacted: function() {
      return this.goods.sendStatus === TRANSACTED_STATUS
    }
  },
  methods: {
    async open(goods) {
      this.goods = goods
      await this.loadBidData()
      this.viewManager.visible = true
    },
    // 成交操作
    refuseBid(transport) {
      const params = {
        ids: this.goods.id,
        offerPrice: transport.offerPrice,
        companyId: transport.companyId,
        sendStatus: TRANSACTED_STATUS
      }
      this.viewManager.loading = true
      batchIssue(params)
        .then(data => {
          this.$message({
            type: 'success',
            message: '已成交!'
          })
          //  发射交易完成事件
          this.$emit('transaction-done')
          setTimeout(() => {
            this.viewManager.close()
          }, 500)
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    },
    invitationFormSummit() {
      this.loadBidData()
    },
    resetInvitationForm() {
      this.cleanModal(this.invitationForm)
      this.loadBidData()
    },
    bidChangeSize(size) {
      this.bidPagination.pageSize = size
      this.loadBidData()
    },
    bidChangeCurrent(current) {
      this.bidPagination.pageNo = current
      this.loadBidData()
    },
    loadBidData() {
      // 模拟请求
      const param = this.exchangeParams(this.invitationForm)
      param.goodsId = this.goods.id
      // 根据消息通知过来的数据进行查询
      if (this.$route.params.data && this.$route.params.data.supplierUserId) {
        param.userId = this.$route.params.data.supplierUserId
      }
      this.viewManager.loading = true
      getBidList(param)
        .then(data => {
          this.bidData = data.result.rows
          this.bidPagination.total = data.result.total
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    },
    exchangeParams(params) {
      const submitHandle = {
        get(target, key, proxy) {
          if (key === 'offerDate') {
            for (const item in target[key]) {
              target[key][item] = formatTime(
                target[key][item],
                'YYYY-MM-DD HH:mm:ss'
              )
            }
            return target[key].toString()
          }
          return target[key]
        }
      }
      if (window && window.Proxy) {
        const p = new Proxy(params, submitHandle)
        return Object.assign({}, p)
      } else {
        const proxyData = {}
        for (const key in params) {
          proxyData[key] = submitHandle.get(params, key)
        }
        return proxyData
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/styles/standardColor.scss";

$main-color: #be2316;
.bid-data {
  .query-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f1f1f1;
    .query-form {
      flex-basis: 75%;
      /deep/.el-form-item {
        width: 100%;
      }
      /deep/.el-form--inline .el-form-item__content {
        width: calc(100% - 120px);
      }
      /deep/.el-date-editor--datetimerange.el-input__inner {
        width: initial !important;
      }
    }
    .operate-tool {
      flex-basis: 25%;
      justify-content: space-evenly;
      display: flex;
    }
  }
  .bid-data-header {
    color: $main-color;
    font-weight: bold;
    background-color: #ffffff;
    height: 51px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
    border-radius: 4px;
    ul {
      display: flex;
      flex-wrap: nowrap;
      line-height: 51px;
      // width: calc(100% - 16px);
      // padding: 8px 8px;
      box-sizing: content-box;
      li {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 15px;
        min-width: 50px;
        height: 100%;
        line-height: 51px;
        text-align: center;
        &:nth-child(1) {
          flex-basis: 16%;
        }
        &:nth-child(2) {
          flex-basis: 16%;
        }
        &:nth-child(3) {
          flex-basis: 16%;
        }
        &:nth-child(4) {
          flex-basis: 16%;
        }
        &:nth-child(5) {
          flex-basis: 16%;
        }
        &:nth-child(6) {
          flex-basis: 16%;
        }
      }
    }
  }
  .bid-data-body {
    position: relative;
    .no-data-info {
      background-color: #fff;
      width: 100%;
      text-align: center;
      margin-top: 8px;
      height: 51px;
      line-height: 48px;
      font-size: 15px;
    }
    .data-item {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
      border-radius: 4px;
      margin: 8px 0px;
      // border: 1px solid #ebeef5;
      position: relative;
      box-sizing: border-box;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 51px;
        // width: calc(100% - 16px);
        // padding: 8px 8px;
        position: relative;
        background-color: white;
        color: rgba(51, 51, 51, 1);
        *::selection {
          background-color: rgba(0, 0, 0, 0) !important;
        }
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 51px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 16%;
          }
          &:nth-child(2) {
            flex-basis: 16%;
          }
          &:nth-child(3) {
            flex-basis: 16%;
          }
          &:nth-child(4) {
            flex-basis: 16%;
          }
          &:nth-child(5) {
            flex-basis: 16%;
          }
          &:nth-child(6) {
            flex-basis: 16%;
          }
        }
      }
      /deep/ .goods-item-details {
        border: 1px solid #ebeef5;
        z-index: 0;
      }
    }
  }
  .bid-data-pagination {
    margin-top: 24px;
    padding: 16px 0;
    background-color: white;
  }
}

.sort {
  &::selection {
    background-color: rgba(0, 0, 0, 0);
  }
  cursor: pointer;
  .caret-wrapper {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    height: 34px;
    width: 24px;
    vertical-align: middle;
    cursor: pointer;
    overflow: initial;
    position: relative;
    .sort-caret {
      width: 0;
      height: 0;
      border: 5px solid transparent;
      position: absolute;
      left: 7px;
      &.ascending {
        top: 5px;
      }
      &.descending {
        bottom: 7px;
      }
    }
  }
  &.ascending {
    .caret-wrapper {
      .sort-caret.ascending {
        border-bottom-color: #409eff !important;
      }
      .sort-caret.descending {
        border-top-color: #c0c4cc;
      }
    }
  }

  &.descending {
    .caret-wrapper {
      .sort-caret.ascending {
        border-bottom-color: #c0c4cc !important;
      }
      .sort-caret.descending {
        border-top-color: #409eff;
      }
    }
  }
}
</style>
